import React, { createContext, useState } from "react";

const CurrentlyPlayingContext = createContext();

const CurrentlyPlayingContextProvider = ({ children }) => {
  const [currentlyPlaying, setCurrentlyPlaying] = useState();

  return (
    <CurrentlyPlayingContext.Provider
      value={{ currentlyPlaying, setCurrentlyPlaying }}
    >
      {children}
    </CurrentlyPlayingContext.Provider>
  );
};

export { CurrentlyPlayingContextProvider, CurrentlyPlayingContext };

// Sample data
// {
//   "title": "Specail Relativity",
//   "artist": "Test User MGI11 ",
//   "cover": "https://workos.imgix.net/images/419f09bc-99ab-4eae-8e71-d33f0577bd47.png?auto=format&fit=clip&q=80&w=500",
//   "url": "http://127.0.0.1:8000/utils/audio-file/audio-8975d72a-0669-4f00-9a67-faf3afa4f604.mp3"
// }
